export default __webpack_public_path__ + "static/media/audio-cross.9e994266.svg";